import {render} from 'react-dom';
import {Provider} from 'react-redux';
import App from 'App';
import {library} from '@fortawesome/fontawesome-svg-core';
import fontawesomeIcons from 'assets/icons/fontawesome';
import React from 'react';
import store from './store';
import {register as registerServiceWorker} from './serviceWorkers/index';
import 'utils/setup/reloadOnChunkError';
import 'utils/setup/setupGTM';
import 'utils/setup/setupSentry';

// TODO : remove after upgrading to react 19, it is like this to avoid compatiblity issues with letrus-ui
global.React = React;

// add icons
library.add(...fontawesomeIcons);

render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root'),
);

registerServiceWorker();
